import {
  DeviceId,
  type DeviceType as UBIFDeviceType,
} from '@service-initiation/shared-clients-tech-care-services';

import { type DeviceType } from '../types/DeviceType';
import { filterPortalAndWebsiteStatus } from './filterPortalAndWebsiteStatus';
import { getDeviceImage } from './getDeviceImage';
import { getDeviceTypeName } from './getDeviceTypeName';
import { isEligibleForColorOptions } from './isEligibleForColorOptions';
import { sortRepairOptions } from './sortRepairOptions';
import { ubifRepairToTechCareRepair } from './ubifRepairToTechCareRepair';

export const ubifDeviceTypesToTechCareDeviceTypes = (
  ubifDeviceTypes: UBIFDeviceType[],
  root = true
): DeviceType[] =>
  filterPortalAndWebsiteStatus(ubifDeviceTypes).map((ubifDeviceType) => {
    const techCareDeviceTypes = ubifDeviceTypesToTechCareDeviceTypes(
      ubifDeviceType.children,
      false
    );
    const children =
      techCareDeviceTypes.length === 1
        ? techCareDeviceTypes.filter((t) => t.id !== DeviceId.OtherChild)
        : techCareDeviceTypes;

    return {
      children,
      family: ubifDeviceType.family,
      hasChildren: children && children.length > 0,
      id: ubifDeviceType.id,
      imageLink: getDeviceImage(ubifDeviceType),
      isBottomLevel:
        (root && children?.length === 0) ||
        Boolean(
          ubifDeviceType.children?.length === 1 &&
            ubifDeviceType.children?.find((c) => c.id === DeviceId.OtherChild)
        ) ||
        ubifDeviceType.is_bottom_level,
      isEligibleForColorOptions: isEligibleForColorOptions(ubifDeviceType),
      manufacturer: ubifDeviceType.manufacturer,
      name: getDeviceTypeName(ubifDeviceType.name.us_en),
      parentDeviceTypeId: ubifDeviceType.parent_device_type_id,
      repairs: sortRepairOptions(
        ubifDeviceType.repairs?.map(ubifRepairToTechCareRepair)
      ),
      rootParentDeviceTypeId: ubifDeviceType.root_parent_device_type_id,
      sortOrder: ubifDeviceType.sort_order,
      status: ubifDeviceType.status,
    };
  });
